;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/join/:token\",\"regex\":\"^/join/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/recipes/:id\",\"regex\":\"^/recipes/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/beta\"},{\"path\":\"/betabound\"},{\"path\":\"/forgot-password\"},{\"path\":\"/mealime\"},{\"path\":\"/privacy\"},{\"path\":\"/reset-password\"},{\"path\":\"/sign-in\"},{\"path\":\"/sign-up\"},{\"path\":\"/terms\"},{\"path\":\"/verify-email\"},{\"path\":\"/welcome\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";import * as Sentry from "@sentry/nextjs";
import {
  sanitizeTelemetryBreadcrumb,
  sanitizeTelemetryEvent,
  sanitizeTelemetrySpan,
} from "@batch-and-bowl/shared/sentry-privacy";

// An absent DSN means "silently disabled" — Sentry.init() with dsn: undefined
// is a no-op, so dev/CI run with zero extra configuration.
Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  release: process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined,
  environment:
    process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  sendDefaultPii: false,
  beforeBreadcrumb: sanitizeTelemetryBreadcrumb,
  beforeSend: sanitizeTelemetryEvent,
  beforeSendTransaction: sanitizeTelemetryEvent,
  beforeSendSpan: sanitizeTelemetrySpan,
  // Full tracing locally, 10% in production to keep transaction volume sane.
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
});

// Required by @sentry/nextjs to instrument App Router client navigations;
// without it the SDK logs "ACTION REQUIRED" at build time and navigation
// transactions are never started.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
